export function priceFormat(price: number): string {
  const commaFormatter = new Intl.NumberFormat('ja');

  return price >= 0 ? commaFormatter.format(price) : '----';
}
